import { trackEvent } from '@fiverr-private/gtm';
import { mixpanel, bigQuery } from '@fiverr-private/obs';

type CPRAOptOutChange = 'in' | 'out';

const MIX_PANEL_EVENTS = {
    CHANGE_OPT_IN: 'Changed CPRA choice opt in',
    CHANGE_OPT_OUT: 'Changed CPRA choice opt out',
};

const trackMixPanel = (change: CPRAOptOutChange) => {
    if (change === 'in') {
        return mixpanel.track(MIX_PANEL_EVENTS.CHANGE_OPT_IN, {});
    }

    mixpanel.track(MIX_PANEL_EVENTS.CHANGE_OPT_OUT, {});
};

const getChangeEvent = (change: CPRAOptOutChange) => `clicked_on_cpra_choice_opt_${change}`;

const trackBigQuery = (change: CPRAOptOutChange) => {
    bigQuery.send({
        group: 'user_action',
        action: {
            type: 'click',
        },
        feature: {
            name: 'cpra',
        },
        type: getChangeEvent(change),
    });
};

const trackGTM = (value: boolean) => trackEvent('clicked_on_cpra_choice', { cpra_opt_out: value });

const getChange = (value: boolean) => (value ? 'out' : 'in');

export const trackCPRAChoiceChange = (value: boolean) => {
    const change = getChange(value);
    trackBigQuery(change);
    trackMixPanel(change);
    trackGTM(value);
};

export const trackPageViewEvent = () => {
    mixpanel.trackPageView({
        'Page Name': 'CPRA Opt Out Page',
    });
};
